import { createStore, createEvent } from "effector";

export type Modals = {
	isModalLogin: boolean,
	isModalAllSuccess: boolean,
}

const mock = {
	isModalBet: false,
	isModalBetB: false,
	isModalLogin: false,
	isModalAllSuccess: false,
}

export const isModalBet = createEvent<boolean>();
export const isModalBetB = createEvent<boolean>();
export const isModalLogin = createEvent<boolean>();
export const isModalAllSuccess = createEvent<boolean>();
export const clear = createEvent();

export const $modals = createStore<Modals>(mock)
	.on(isModalBet, (state, isModalBet) => { return {...state, isModalBet}; })
	.on(isModalBetB, (state, isModalBetB) => { return {...state, isModalBetB}; })
	.on(isModalLogin, (state, isModalLogin) => { return {...state, isModalLogin}; })
	.on(isModalAllSuccess, (state, isModalAllSuccess) => { return {...state, isModalAllSuccess}; })
	.reset(clear);
